import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ptJSON from './locales/pt/translation.json';
import enJSON from './locales/en/translation.json';
import esJSON from './locales/es/translation.json';

const resources = {
  pt: { translation: ptJSON },
  en: { translation: enJSON },
  es: { translation: esJSON },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('app_language') || 'pt',
  fallbackLng: 'pt',
  interpolation: { escapeValue: false },
  react: { useSuspense: false }, // ajuste conforme sua preferência
});
export default i18n;
